import { getGdprCookie } from "../gdpr/domain/gdpr-provider";
import { getHiddenDataString } from "../../domain/hidden-data-provider";

export default class YotpoPreviewList{

    static Init(yotpoEl,yotpoApiKey,skuNum, productImg, productTitle) {
        const gdpr = getGdprCookie();
        const GDPRisFunctional = gdpr.IsFunctional;


        //if(window.gdpr && window.gdpr.isFunctional) {
        if(GDPRisFunctional) {
            //console.log(`X1. yotpoApiKey: ${yotpoApiKey} | skuNum: ${skuNum} | productImg: ${productImg} }`);

            if(!productTitle || productTitle === '')
                productTitle =null;
            const domain = window.location.host;
            const productUrl = window.location.href;

            //------------------

            if(yotpoEl) {
                /*
                 <div
                     class="yotpo-widget-instance"
                     data-yotpo-instance-id="669497"
                     data-yotpo-product-id="Product ID"
                     data-yotpo-name="Product Title"
                     data-yotpo-url="The URL of your product page"
                     data-yotpo-image-url="The product image URL"
                     data-yotpo-price="Product Price"
                     data-yotpo-currency="Product Currency"
                     data-yotpo-description="Product Description"></div>
                  */
                if(!yotpoEl.classList.contains('yotpo-widget-instance')) {
                    yotpoEl.classList.add('yotpo-widget-instance');
                }

                yotpoEl.setAttribute('data-yotpo-instance-id', getHiddenDataString('yotpo-instance-id'));
                yotpoEl.setAttribute('data-yotpo-product-id', skuNum);
                yotpoEl.setAttribute('data-yotpo-name', productTitle);
                yotpoEl.setAttribute('data-yotpo-url', productUrl);
                yotpoEl.setAttribute('data-yotpo-image-url', productImg);
                yotpoEl.setAttribute('data-appkey', yotpoApiKey);
                yotpoEl.setAttribute('data-domain', domain);
                yotpoEl.classList.remove('hidden');

                /*
                yotpoEl.setAttribute('data-appkey', yotpoApiKey);
                yotpoEl.setAttribute('data-domain', domain);
                yotpoEl.setAttribute('data-product-id', skuNum);
                yotpoEl.setAttribute('data-name', productTitle);
                yotpoEl.setAttribute('data-url', productUrl);
                yotpoEl.setAttribute('data-image-url', productImg);*/


                // Call Youtpo script
                // <script src="https://cdn-widgetsrepository.yotpo.com/v1/loader/{key from azure}" async></script>
                window.yotpo_app_key = yotpoApiKey;
                (function e1() {
                    var e = document.createElement('script');
                    e.type = 'text/javascript';
                    e.async = true;
                    e.src = `https://cdn-widgetsrepository.yotpo.com/v1/loader/${yotpoApiKey}`; // "//staticw2.yotpo.com/" + yotpoApiKey + "/widget.js";
                    var t = document.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(e, t)
                })();
            }
        }
        else {
            console.log('NOT window.gdpr && window.gdpr.isFunctional');
        }

    }


}

